import VxeTableFooter from './src/footer'

VxeTableFooter.install = function (Vue) {
  Vue.component(VxeTableFooter.name, VxeTableFooter)
}

export const Footer = VxeTableFooter
export default VxeTableFooter
